import React from "react";

const SideStrut = ({ height, position, rotation, config, almColor }) => {
    let yanDikmeBoy = height / 1000 + ((config.hasDrapery ? 2 : 1)* 0.06);
    const SIDE_PROFILE_WIDTH = 0.05;

  return (
    <group position={position}>
        <mesh
            key="side-profile-start"
            rotation={rotation}
          >
            <boxGeometry args={[SIDE_PROFILE_WIDTH, yanDikmeBoy, 0.05]} />
            <meshStandardMaterial color={almColor} />
          </mesh>
    </group>
  );
};

export default SideStrut;